module.exports = __webpack_public_path__ + "mo/img/puzzle.a2495568.svg";